import Text from "components/Text";
import styled, { css } from "styled-components";
import { colors } from "theme/colors";
import { SidebarItemProps } from "./types";
import theme from "theme";

export const ActiveItemStyles = ({ isActive }: SidebarItemProps) => {
    return isActive
        ? css`
              background-color: ${colors.purple.tertiary};
              color: ${colors.purple.primary};
          `
        : css`
              background-color: #fff;
              color: ${colors.grey.secondary};

              @media (${theme.breakpoints.mobileL}) {
                ${Text.Style} {
                    display: none;
                }
              }
          `;
};

export const ItemWrapper = styled.span<SidebarItemProps>`
    padding: 14px 10px;
    ${ActiveItemStyles}
    transition: 0.1s all ease-in-out;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    border-radius: 8px;
    &:hover {
        background-color: ${colors.purple.tertiary};
        color: ${colors.purple.primary};
        ${Text.Style} {
            color: ${colors.purple.primary};
        }
    }
`;

export const IconImage = styled.img`
    width: 12px;
    height: 12px;
`;
